"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_BUTTON_ALIGNMENTS = void 0;
// eslint-disable-next-line import/prefer-default-export
const FORM_BUTTON_ALIGNMENTS = ["left", "right"];
exports.FORM_BUTTON_ALIGNMENTS = FORM_BUTTON_ALIGNMENTS;